export const modalDataSelector = state => state.common.modalData;
export const editableDataSelector = state => state.common.editableItem;

export const categoriesList = state => state.common.categories;

export const categoriesLoadingSelector = state => state.common.categoriesLoading;
export const currentRestaurantSelector = state => state.common.currentRestaurant;
